import { memo } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { useAuthData } from "./auth-data-context";

/** Renders the signed-in routes, or sends signed-out users to /login. */
export const AuthGuard = memo(function AuthGuard() {
  const { status } = useAuthData();

  if (status === "loading") {
    return null;
  }
  if (status === "unauthenticated") {
    return <Navigate replace to="/login" />;
  }
  return <Outlet />;
});
